import { useState, useEffect } from "react"
import styles from './sort.module.css'
import logEvent from "lib/ga/miscEvent";
import logSearchPageFilter from "lib/ga/searchPageFilter";

const googleEvents = (location: string, value: object, filterLabel: string) => {
    logEvent({
        category: "Flexible Search",
        action: "Filter Applied",
        label: `Location: ${location}, Filter: ${filterLabel}, Value: ${JSON.stringify(value)}`,
    });

    logSearchPageFilter({
        filter: filterLabel,
        value: JSON.stringify(value),
        state: "add",
    });
}

type Props = {
    onChange: any,
    options: {
        [key: string]: {
            label: string,
            value: string
        }
    }
    value: string
    defaultSortOrder: string | null
}

const SortLayout = ({ onChange, options, value, defaultSortOrder = null }: Props) => {

    const [showSort, setShowSort] = useState(false);

    const checkForMenuClose = (e) => {
        if (e.target.id !== 'sort') {
            setShowSort(false);
        }
    };


    useEffect(() => {
        window.addEventListener("click", checkForMenuClose);
        return () => {
          window.removeEventListener("click", checkForMenuClose);
        };
    });

    const checkDefault = JSON.stringify(defaultSortOrder);

    const index = options.findIndex((o) => {
        return o.value === value || o.value === checkDefault
    })
    const title = index > 0 ? options[index].label : '↓↑  Sort'
    return (
        <section className={styles.Container}>
            <div  className={styles.div}>
                <button  className={styles.button} id="sort" onClick={(e) => {
                    setShowSort(!showSort)
                }}>
                    {title}
                </button>
                <ul className={!showSort ? `${styles.displayNone} ${styles.ul}` : styles.ul}>
                    {options.map((sort) => (
                        <li className={styles.li} key={sort.label} onClick={(e) => {
                            onChange(sort.value);
                            //googleEvents(location, sort.value, 'sort')
                        }} >
                            {sort.label}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}

export default SortLayout;